import { connect } from 'react-redux';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { addonQuoteCancelled } from 'state/addonForm/addonForm.action';
import { addonQuoteTradeRequestedThunk } from 'state/addonForm/addonForm.thunks';
import { addonSelector, canTradeBackToBack } from 'state/selectors';
import { getTradeConfirmationByQuoteId } from 'state/selectors/common/temp';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { QuoteWorkspaceType } from 'state/workspaces/model';

export interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

export interface StateProps {
  enableTrade: boolean;

  hadTraded: boolean;
}

export interface DispatchProps {
  onCancel(): void;
  onTrade(): void;
}

export type TradeActionsProps = StateProps & DispatchProps;

const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const quoteId = addonSelector.getLastQuoteId(state, tabId);
  const confirmation = getTradeConfirmationByQuoteId(state, quoteId);
  const hadTraded = confirmation?.hadTraded ?? false;
  const enableTrade = canTradeBackToBack(state, workspaceType, tabId);

  return {
    enableTrade,
    hadTraded,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps => ({
  onCancel() {
    logAnalytics.trackEvent('Addon', 'Cancel tradable quote');
    dispatch(addonQuoteCancelled(tabId));
  },
  onTrade() {
    logAnalytics.trackEvent('Addon', 'Request for trade');
    dispatch(addonQuoteTradeRequestedThunk(tabId));
  },
});

export const connectTradeAction = connect(mapStateToProps, mapDispatchToProps);
